import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { isEmptyObj } from 'src/app/helper/class/utilityHelper';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppointmentApiService {

  module = 'appointment'
  constructor(private http: HttpClient) { }

  saveAppointment(data: any) {
    return lastValueFrom(this.http.post(`${this.module}/save`, data))
  }

  rescheduleAppointment(data: any, id: any) {
    return lastValueFrom(this.http.post(`${this.module}/reschedule/${id}`, data))
  }

  appointmentByDoctor(data: any) {
    return lastValueFrom(this.http.post(`${this.module}/getAll`, data))
  }
  deleteAppointment(id: any) {
    return lastValueFrom(this.http.post(`${this.module}/delete/${id}`, {}));
  }
  getList(ev : any){
    const lasyP = isEmptyObj(ev) ? '' : '/' + JSON.stringify(ev);
    return lastValueFrom(this.http.get(`${this.module}/getList/${lasyP}`));
  }
}
